/**
 * Grupo internacional (ardevilla/espanha/demofixept — passbook.hasPT/hasES/hasIN):
 * o legado usa a lib `intl-tel-input` com autodetecção de país por geo-IP
 * (`ipinfo.io`). Aqui optamos por um seletor de DDI curado (sem nova
 * dependência nem chamada a serviço de geolocalização de terceiro) — o
 * identificador único continua sendo `{ddi}{telefone}`, que é a regra de
 * negócio real; a autodetecção de país é só UX, não regra de negócio.
 */
export interface CountryDialOption {
  iso2: string;
  dialCode: string;
  label: string;
  /** Emoji de bandeira — renderiza igual em qualquer tema (light/dark), sem asset novo. */
  flag: string;
}

export const INTL_PHONE_COUNTRIES: CountryDialOption[] = [
  { iso2: 'pt', dialCode: '351', label: 'Portugal', flag: '🇵🇹' },
  { iso2: 'es', dialCode: '34', label: 'Espanha', flag: '🇪🇸' },
  { iso2: 'br', dialCode: '55', label: 'Brasil', flag: '🇧🇷' },
  { iso2: 'gb', dialCode: '44', label: 'Reino Unido', flag: '🇬🇧' },
  { iso2: 'us', dialCode: '1', label: 'Estados Unidos', flag: '🇺🇸' },
];

export function defaultDialCode(locale: 'pt' | 'es' | 'en'): string {
  if (locale === 'es') return '34';
  if (locale === 'en') return '44';
  return '351';
}

export function isValidIntlPhoneDigits(digits: string): boolean {
  return digits.length >= 6 && digits.length <= 13;
}
